export const BORDER_WIDTHS = {
  thin: { value: '1px' },
  thick: { value: '2px' },
  medium: { value: '1.5px' },
};
